export default () => ({
  step: 1,
  user: { badgeId: '', name: '' },
  checkoutsList: { checkouts: [], entries: [], error: null, loading: false },
  playerSearch: { query: '', loading: false, results: [], error: false },
  play: { checkoutId: null, game: '', players: [] }
});
